

















































































































































































import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { ApiError } from '@sonicwall/unified-ui-framework/src/shared/api-service';
import { ManageProductUserGroupPayload, PartyMSSPResponse } from '../../types';
import { MswApiService } from '@/shared/msw-api-service';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';

const cssPrefix = 'assign-tenants-modal';

@Component({
  components: {
    SwTextfield,
    SwScrollView,
    SwButton,
    SwCheckbox,
  },
})

export default class AssignTenantsModal extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Watch('showAssignTenantModal')
  @Watch('selectedUserGroupDetail')
  onShowAssignTenantModal() {
    const { assignedProductGroup = [], availbleProductGroup: availableProductGroup = [] } = this.tenantsForUserGroup as any;
    this.selectedTenants = assignedProductGroup;
    this.availableTenants = availableProductGroup;
  }

  selectedTenants: any = [];
  availableTenants: any = [];
  filteredAvailableTenants: any = [];
  searchTenantsValue: string = '';
  checkedTenant: boolean = true;
  unCheckedTenant: boolean = false;
  enableAvailableTenantFilter: boolean = false;
  isAffliated: boolean = false;

  get disableAddButton() {
    return this.selectedTenants?.length <= 0;
  }

  get tenantsForUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getTenantsForUserGroup'] || [];
  }

  get availableTenantsListing() {
    return this.enableAvailableTenantFilter ? this.filteredAvailableTenants : this.availableTenants;
  }

  get showAssignTenantModal() {
    return this.$store.getters['MswUserGroupStoreModule/getShowAssignTenantModal'];
  }

  get selectedUserGroupId() {
    return this.$store.getters['MswUserGroupStoreModule/getSelectedUserGroup'][0] || {};
  }

  get selectedUserGroupDetail() {
    return this.$store.getters['MswUserGroupStoreModule/getSelectedUserGroupDetail'][0] || {};
  }

  get userGroups() {
    return this.$store.getters['MswUserGroupStoreModule/getUserGroups'] || [];
  }

  emitSelectedTenants() {
    this.$emit('selected-tenants', this.selectedTenants);
  }

  onCheckedSelectedTenant(list: any) {
    this.selectedTenants = this.selectedTenants?.filter((ele: any) => ele?.productGroupId !== list?.productGroupId);
    this.availableTenants = [...this.availableTenants, list];
    if (this.enableAvailableTenantFilter) this.onSearchTenants();
    this.checkedTenant = true;
    // if (this.userGroupStore?.showAssignTenantsAndUserGroupsModal) this.emitSelectedTenants();
  }

  onCheckedAvailableTenant(list: any) {
    this.availableTenants = this.availableTenants?.filter((ele: any) => ele?.productGroupId !== list?.productGroupId);
    if (this.enableAvailableTenantFilter) this.onSearchTenants();
    this.selectedTenants = [...this.selectedTenants, list];
    this.unCheckedTenant = false;
    // if (this.userGroupStore?.showAssignTenantsAndUserGroupsModal) this.emitSelectedTenants();
  }

  onSearchTenants() {
    if (this.searchTenantsValue?.trim()) {
      this.enableAvailableTenantFilter = true;
      this.filteredAvailableTenants = this.availableTenants.filter((tenant: any) => tenant?.productGroupName?.toLowerCase().includes(this.searchTenantsValue?.toLowerCase()));
    } else {
      this.enableAvailableTenantFilter = false;
    }
  }

  compareArrays(arrOne: any, arrTwo: any) {
    return JSON.stringify(arrOne) === JSON.stringify(arrTwo);
  }

  loadProductGroupsForUserGroup() {
    return new Promise((resolve, reject) => {
      this.$store.commit('MswUserGroupStoreModule/setLoadingTenantsForUserGroup', true);
      MswApiService.createCustomer.listProductGroupForUserGroup(this.selectedUserGroupId)
      .then((resp: any) => {
        this.$store.commit('MswUserGroupStoreModule/setLoadingTenantsForUserGroup', false);
        this.$store.commit('MswUserGroupStoreModule/setTenantsForUserGroup', { ...resp?.content });

        resolve(true);
      })
      .catch((error: ApiError) => {
        reject(true);
        this.$store.commit('displayMessage', { infoType: 'high', infoMsg: error?.message });
      });
    });
  }

  updateTenantsForUserGroup() {
    const tenantsForUserGroup = { assignedProductGroup: [...this.selectedTenants], availbleProductGroup: [...this.availableTenantsListing] };
    this.$store.commit('MswUserGroupStoreModule/setTenantsForUserGroup', tenantsForUserGroup);
  }

  onManageTenants() {
    const { assignedProductGroup = [] } = this.selectedUserGroupDetail || {};
    if (this.compareArrays(assignedProductGroup, this.selectedTenants)) return;
    const payload: ManageProductUserGroupPayload = {
      bsendMail: false,
      partyProductGroupList: [
        ...this.selectedTenants?.map((ele: any) => {
          return { productGroupId: ele?.productGroupId, partyGroupId: this.selectedUserGroupId };
        }),
      ],
    };
    this.$store.commit('startLoading');
    MswApiService.createCustomer.postManageUserProductGroup(payload)
    .then((resp: PartyMSSPResponse) => {
      this.$store.commit('stopLoading');
      if (resp?.operationStatus === 'OK') {
        this.$store.commit('MswUserGroupStoreModule/setShowAssignTenantModal', false);
        this.updateTenantsForUserGroup();
        this.$store.commit('displayMessage', { infoType: 'success', infoMsg: resp?.msgDesc });
      } else {
        this.$store.commit('displayMessage', { infoType: 'high', infoMsg: resp?.msgDesc });
      }
    })
    .catch((error: ApiError) => {
      this.$store.commit('stopLoading');
      this.$store.commit('displayMessage', { infoType: 'high', infoMsg: error?.message });
    });
  }

  created() {
    const usergroup = this.userGroups?.filter((ele: any) => (ele?.partyGroupId === this.selectedUserGroupId));
    this.isAffliated = usergroup[0]?.isAffilated === 'YES' ? true : false;
  }
}
